import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'page-content',
    templateUrl: './page-content.component.html',
    styleUrls: ['./page-content.component.scss'],
    standalone: false
})
export class PageContentComponent implements OnInit {

  @Input() noPadding = false;

  constructor() {
  }

  ngOnInit() {
  }

}
